import PropTypes from 'prop-types';
import { useDictionary } from '../../../../../../../utilities/hooks/UseDictionary';
import ProfileImage from '../../../../../common/ProfileImage';

const BookingPaticipants = ({ participant,index }) => {
    const dictionary = useDictionary();
    
	return (
		<div
			key={index}
			className="participant-row-container"
			style={{ marginBottom: (window.innerWidth > 767 ? '16px' : '8px') }}
		>
            <div className='d-flex items-center booking-participants-container'>
                <div className='d-flex items-center participant-column name-column'>
                    <ProfileImage name={participant.name} photo={participant?.avatar_url} size={{ width: 40, height: 40,fontSize: 14, lineHeight: 16 }}/>
                    <h4 className='truncate' style={{ fontWeight: 'normal',maxWidth:'250px', marginLeft: '8px' }}>
                        {participant.name ? participant.name : `${dictionary.participant} ${index+1}`}
                    </h4>
                </div>
                <div className='participant-column'>
                    <h4 className='truncate' style={{ fontWeight: 'normal', maxWidth:'120px', opacity: '0.6' }}>
                        {participant.participant_group}
                    </h4>
                </div>
                <div className='participant-column'>
                    <h4 style={{ fontWeight: 'normal', opacity: '0.6' }}>
                        ({`${participant.check_in}/${participant.check_in_allowed_quantity}`})
                    </h4>
                </div>
            </div>
            {/* <div className='flex-filler'/>
            <div className='d-flex'>
                <h4 style={{ fontSize: '12px', cursor: 'pointer',padding: '8px' }}>{dictionary.edit}</h4>
                <h4 style={{ fontSize: '12px', cursor: 'pointer',padding: '8px', color:'#FD4F4F' }}>{dictionary.remove}</h4>
            </div> */}
		</div>
	);
};

BookingPaticipants.propTypes = {
	participant: PropTypes.object.isRequired
};

export default BookingPaticipants;
